import React, { useState } from "react";
import {
    FaBars,
    FaTimes,
    FaUsers,
    FaSignOutAlt,
    FaDatabase,
    FaListAlt
} from "react-icons/fa";
import logo from "../../assets/images/elektrokrajina.png";
import elmapLogo from "../../assets/images/elmap-logo-transparent.png";
import { FaCog } from "react-icons/fa";
import DynamicModal from "../Modal/DynamicModal";
import Codebook from "../../utils/Codebook/Codebook";
import EnumDataManagement from "../../utils/EnumDataManagement/EnumDataManagement";
import { getUserInfo } from "../../utils/LoginForm/Auth/auth";
import { useAuth } from "../../utils/LoginForm/Auth/AuthProvider";
import { useAccessRights } from "../../utils/LoginForm/Auth/useAccessRights";
import "./Header.css";
import { BASE_URL } from "../../config";
import Statistics from "../../utils/Statistics/Statistics";

function Header({
    isMenuOpen,
    setIsMenuOpen,
    setOverlay,
    ojInfo,
    setWfsLayers,
    setWmsLayers,
    setLasLayers,
    setActivePanel,
    setIsLeftSidebarCollapsed
}) {
    const [showPageModal, setShowPageModal] = useState(false);
    const [showSettingsDropdown, setShowSettingsDropdown] = useState(false);
    const [showShifarniciModal, setShowShifarniciModal] = useState(false);
    const [showDataTypesModal, setShowDataTypesModal] = useState(false);
    const [showPdfModal, setShowPdfModal] = useState(false);

    const { isAuthenticated, logout } = useAuth();
    const { accessProfile } = useAccessRights();

    const user = getUserInfo();

    const userInfo = user
        ? {
            name: user.given_name || "",
            surname: user.family_name || ""
        }
        : null;

    const canAccessTabs =
        accessProfile.canRead.value ||
        accessProfile.canWrite.value ||
        accessProfile.canReadOrgJedinicu.value ||
        accessProfile.canWriteOrgJedinicu.value;

    const handleLogout = () => {
        setShowSettingsDropdown(false);
        logout();
    };

    const closePageModal = () => {
        setShowPageModal(false);
    };

    const openPageModal = () => {
        setShowPageModal(true);
        setShowSettingsDropdown(false);
    };

    const openShifarniciModal = () => {
        setShowShifarniciModal(true);
        setShowSettingsDropdown(false);
    };

    const closeShifarniciModal = () => {
        setShowShifarniciModal(false);
    };

    const openDataTypesModal = () => {
        setShowDataTypesModal(true);
        setShowSettingsDropdown(false);
    };

    const closeDataTypesModal = () => {
        setShowDataTypesModal(false);
    };

    const closePdfModal = () => {
        setShowPdfModal(false);
    };

    return (
        <header className="header">
            <div className="menu-logo">
                <button
                    onClick={() => {
                        if (canAccessTabs) {
                            if (!isMenuOpen) {
                                setActivePanel(null);
                                setLasLayers([]);
                                setIsMenuOpen(true);
                            } else {
                                setIsLeftSidebarCollapsed(false);
                                setIsMenuOpen(false);
                            }
                        }
                    }}
                    className="menu-button"
                    title={canAccessTabs ? "Naponske mreže" : "Nemate pristup naponskim mrežama"}
                    disabled={!canAccessTabs}
                    style={{
                        cursor: canAccessTabs ? "pointer" : "not-allowed",
                        opacity: canAccessTabs ? 1 : 0.5,
                    }}
                >
                    {isMenuOpen ? <FaTimes /> : <FaBars />}
                </button>
            </div>

            <div className="center-logos">
                <img
                    src={logo}
                    alt="Elektrokrajina logo"
                    className="logo elektro-logo"
                />

                <img
                    src={elmapLogo}
                    alt="Elmap logo"
                    className="logo elmap-logo"
                />
            </div>

            <div className="user-info">
                {isAuthenticated && userInfo && (
                    <>
                        <span className="user-name">
                            {userInfo.name} {userInfo.surname}
                        </span>

                        <div className="settings-dropdown">
                            <FaCog
                                className="settings-icon"
                                onClick={() => setShowSettingsDropdown(prev => !prev)}
                                title="Podešavanja"
                            />

                            {showSettingsDropdown && (
                                <div className="dropdown-content">
                                    <div className="statistics-dropdown-section">
                                        {ojInfo.isAuthenticated && (
                                            <Statistics ojInfo={ojInfo} />
                                        )}
                                    </div>

                                    <button
                                        onClick={openPageModal}
                                        className="dropdown-item"
                                    >
                                        <FaUsers size={18} />
                                        Upravljanje korisnicima
                                    </button>

                                    <button
                                        onClick={openShifarniciModal}
                                        className="dropdown-item"
                                    >
                                        <FaListAlt size={18} />
                                        Upravljanje šifarnicima
                                    </button>

                                    <button
                                        onClick={openDataTypesModal}
                                        className="dropdown-item"
                                    >
                                        <FaDatabase size={18} />
                                        Upravljanje tipovima podataka
                                    </button>

                                    <button
                                        onClick={handleLogout}
                                        className="dropdown-item"
                                    >
                                        <FaSignOutAlt size={18} />
                                        Odjavite se
                                    </button>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>

            <DynamicModal
                isOpen={showPageModal}
                onRequestClose={closePageModal}
                title="Upravljanje korisnicima"
                mainContent={
                    <iframe
                        src={`${BASE_URL}/auth`}
                        title="Embedded Page"
                        width="1000px"
                        height="700px"
                        style={{ border: "none" }}
                    />
                }
                footerContent={
                    <button
                        onClick={closePageModal}
                        className="app-btn app-btn-secondary"
                    >
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />

            <DynamicModal
                isOpen={showShifarniciModal}
                onRequestClose={closeShifarniciModal}
                title="Upravljanje šifarnicima"
                mainContent={
                    <Codebook setOverlay={setOverlay} />
                }
                footerContent={
                    <button
                        onClick={closeShifarniciModal}
                        className="app-btn app-btn-secondary"
                    >
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />

            <DynamicModal
                isOpen={showDataTypesModal}
                onRequestClose={closeDataTypesModal}
                title="Upravljanje tipovima podataka"
                mainContent={
                    <EnumDataManagement setOverlay={setOverlay} />
                }
                footerContent={
                    <button
                        onClick={closeDataTypesModal}
                        className="app-btn app-btn-secondary"
                    >
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />

            <DynamicModal
                isOpen={showPdfModal}
                onRequestClose={closePdfModal}
                title="Pregled PDF dokumenta"
                mainContent={
                    <iframe
                        src="/pdfs/Корисничко упутство за софтверски програм ELMAP.pdf"
                        title="PDF Viewer"
                        width="100%"
                        height="100%"
                        style={{ border: "none" }}
                    />
                }
                footerContent={
                    <button
                        onClick={closePdfModal}
                        className="app-btn app-btn-secondary"
                    >
                        Zatvori
                    </button>
                }
                customHeight="85vh"
                customWidth="75vw"
                customZIndex={1000}
            />
        </header>
    );
}

export default Header;